import { Box, Heading, HStack, Text } from "@chakra-ui/react"
import type { ReactNode } from "react"
import { BarcodeSvg } from "../ProductionOrders/barcode"
import DocumentStatusBadge from "./DocumentStatusBadge"

type DocumentPageHeaderProps = {
  number: string
  status?: string | null
  labelColor: string
  actions: ReactNode
  showBarcode?: boolean
  statusIndicator?: ReactNode
}

export default function DocumentPageHeader({
  number,
  status,
  labelColor,
  actions,
  showBarcode = false,
  statusIndicator,
}: DocumentPageHeaderProps) {
  return (
    <HStack justify="space-between" mb={4} align="center">
      <HStack spacing={showBarcode ? 4 : 0}>
        <HStack>
          <Heading size="lg">{number}</Heading>
          <DocumentStatusBadge status={status} fontSize="md" />
          {statusIndicator}
        </HStack>
        {showBarcode ? (
          <Box
            textAlign="center"
            px={4}
            py={2}
            borderWidth="1px"
            borderRadius="md"
          >
            <BarcodeSvg value={number} maxWidth={200} />
            <Text fontSize="xs" mt={1} letterSpacing="2px" color={labelColor}>
              {number}
            </Text>
          </Box>
        ) : null}
      </HStack>
      {actions}
    </HStack>
  )
}
